import * as React from "react";
import AboutColor from "../containers/AboutColor";
import greenQuotation from "../containers/AboutColor/greenQuotation";
import greenParrot from "../containers/AboutColor/greenParrot.png";
import COLOR_TYPES from "../common/colors/type";
import t from "../translations";

export default (props) => (
  <AboutColor
    {...props}
    authorName={t("routes_GreenAboutColorsPageRoute_autorName")}
    title={t("routes_GreenAboutColorsPageRoute_title")}
    image={greenParrot}
    quotation={greenQuotation}
    colorType={COLOR_TYPES.GREEN}
  />
);
